import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-all-faq',
  templateUrl: './all-faq.component.html',
  styleUrls: ['./all-faq.component.css']
})
export class AllFaqComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
